import styled from 'styled-components';
import colors from '../../../assets/colors';

const ListItem = styled.div`
  background-color: ${props => (props.selected ? '#E9E9E9' : 'none')};
  border: 1px solid #E9E9E9;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  cursor: pointer;

  h2 {
    font-size: 0.9rem;
    font-weight: 600;
    color: ${colors.primary};
  }

  p {
    display: ${props => (props.selected ? 'block' : 'none')};
    padding-top: 10px;
    font-size: 0.9rem;
  }

  :hover { opacity: ${props => (props.selected ? 1 : 0.8)}; }
  :last-child { margin-bottom: 0 }
`;
export default ListItem;
